import { memo } from 'react';

import { CustomContent, CustomHeading2, CustomHeading3, CustomHeading4 } from '@components/text';

import { useTranslatedFieldText } from './locale';
import { Heading2Field, Heading3Field, LabelField, ParagraphField } from './types';

export const Label = memo<{ field: LabelField }>(({ field }) => {
  return <CustomHeading4 text={useTranslatedFieldText(field.text)} />;
});

export const Paragraph = memo<{ field: ParagraphField }>(({ field }) => (
  <CustomContent
    text={
      <span
        dangerouslySetInnerHTML={{
          __html: useTranslatedFieldText(field.text).replace(/\n/g, '<br/>'),
        }}
      />
    }
  />
));

export const Heading = memo<{ field: Heading2Field }>(({ field }) => (
  <CustomHeading2 text={useTranslatedFieldText(field.text)} />
));

export const SubHeading = memo<{ field: Heading3Field }>(({ field }) => (
  <CustomHeading3 text={useTranslatedFieldText(field.text)} />
));
